import { Button } from "~/components/button";
import { Container } from "~/components/container";
import { FadeIn } from "~/components/fade-in";
import { Offices } from "~/components/offices";
import { delivery } from "~/lib/site";

export function ContactSection() {
  return (
    <Container className="mt-24 sm:mt-32">
      <FadeIn className="rounded-2xl border border-ink-700 bg-ink-900 px-6 py-14 sm:px-12 sm:py-20">
        <div className="max-w-2xl">
          <p className="label text-accent-400">Start here</p>
          <h2 className="mt-5 font-display text-3xl font-medium tracking-tight text-ink-50 [text-wrap:balance] sm:text-4xl">
            Tell us what you&rsquo;re trying to ship.
          </h2>
          <p className="mt-5 text-base text-ink-300">
            Send us the platforms, the deadline and what is in the way. You get
            a reply within {delivery.responseTime} with our first read on it and
            what we would do next — no pitch deck, no discovery retainer.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-4">
            <Button to="/contact" size="lg">
              {delivery.callLabel}
            </Button>
            <Button to={`mailto:${delivery.email}`} size="lg" variant="outline">
              Email us instead
            </Button>
          </div>
          <div className="mt-12 border-t border-ink-700 pt-8">
            <h3 className="label text-ink-400">Our office</h3>
            <Offices className="mt-5" />
          </div>
        </div>
      </FadeIn>
    </Container>
  );
}
